var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.594v6.452l5.826 3.363V10.228L17.152 4.067a.495.495 0 00-.742.43v5.87L22 13.594z",
    fill: "#008367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.046l-5.59 3.227-5.59-3.227-5.084 2.937a.495.495 0 000 .856l10.674 6.16 11.416-6.59L22 20.046z",
    fill: "#40B15D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.085 7.294L5 10.23v5.87c0 .38.413.62.742.43l5.084-2.937v-5.87c0-.38-.412-.62-.741-.43z",
    fill: "#0080CB"
  })));
}
export default SvgLogo;